
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import { useSearchParams } from "react-router-dom";

// Importing translation files

import translationEN from "./en/translation.json";
import translationAR from "./ar/translation.json";
import translationES from "./es/translation.json";
import translationFR from "./fr/translation.json";
import translationHI from "./hi/translation.json";
import translationPT from "./pt/translation.json";
import translationSI from "./si/translation.json";
import translationZH from "./zh/translation.json";

//Creating object with the variables of imported translation files
const resources = {
    en: {
        translation: translationEN
    },
    ar: {
        translation: translationAR
    },
    es: {
        translation: translationES
    },
    fr: {
        translation: translationFR
    },
    hi: {
        translation: translationHI
    },
    pt: {
        translation: translationPT
    },
    si: {
        translation: translationSI
    },
    zh: {
        translation: translationZH
    }
};

//i18N Initialization
i18n
    .use(initReactI18next)
    .init({
        resources,
        lng:check_url_segments(), //default language
        interpolation: {
            escapeValue: false,
        },
    });

function check_url_segments(){
 const queryParameters = new URLSearchParams(window.location.search);
    const lang = queryParameters.get("lang");

    const otherLangs = [
        'ar',
        'es',
        'fr',
        'hi',
        'pt',
        'si',
        'zh'
    ];

    if (lang !== null && lang !== '' && otherLangs.includes(lang)) {
        return lang;
    } else {
        return 'en';
    }
}

export default i18n;